import React from 'react';
import PropTypes from 'prop-types';
import { AuditTimelineV2 } from '../../../components/v2';
import useNsirHistorico from './hooks/useNsirHistorico';

const tabPanelBleedSx = {
  m: { xs: -2, sm: -2.5 },
  p: { xs: 1.5, sm: 2 },
  pt: { xs: 0.25, sm: 0.375 },
};

const AuditTab = ({ nsirId }) => {
  const { items, loading, loadError, refetch } = useNsirHistorico(nsirId, {
    enabled: Boolean(nsirId),
  });

  return (
    <AuditTimelineV2
      items={items}
      loading={loading}
      loadError={loadError}
      onRefresh={refetch}
      disabled={!nsirId}
      emptyMessage="O histórico aparecerá aqui quando houver mudanças nesta NSIR."
      sx={tabPanelBleedSx}
    />
  );
};

AuditTab.propTypes = {
  nsirId: PropTypes.string,
};

AuditTab.defaultProps = {
  nsirId: null,
};

export default AuditTab;
